/**
 * 교과별 맞춤 콘텐츠 (성취기준 기반) - 2025.09.24 대규모 확장
 * ⚠️ 주의: 이 데이터는 완전하지 않으며 참고용입니다.
 * 정확한 성취기준은 국가교육과정정보센터(ncic.re.kr)를 확인하세요.
 */

// 교과별 맞춤 예시 (대폭 확장)
export const subjectSpecificExamples = {
  국어: [
    "문학 작품 속 인물의 감정을 깊이 있게 이해하고 자신의 삶과 연결하여 감상문을 작성함.",
    "사회적 쟁점에 대한 토론에서 논리적 근거를 들어 자신의 주장을 설득력 있게 펼침.",
    "시 창작 활동에서 비유와 상징을 활용하여 자신의 감정을 독창적으로 표현함.",
    "고전 문학 작품을 현대적 시각에서 재해석하여 발표하며 창의적인 안목을 보여줌.",
    "매체 자료의 특성을 비판적으로 분석하고 자신의 의견을 담은 영상 논평을 제작함.",
    "어휘력이 풍부하고 문장 구사 능력이 뛰어나 간결하면서도 의미가 명확한 글을 씀.",
    "친구의 발표를 경청하고 핵심 내용을 요약하며 건설적인 질문을 하는 등 소통 능력이 뛰어남.",
    "주제 통합적 독서를 통해 얻은 지식을 바탕으로 새로운 관점을 제시하는 보고서를 작성함.",
    "문법 지식을 바탕으로 자신의 글을 스스로 점검하고 오류를 수정하는 자기주도적 학습 태도를 보임."
  ],
  수학: [
    "복잡한 함수의 그래프를 분석하여 실생활 문제의 최적화 해법을 찾아내는 모델링 능력을 보여줌.",
    "기하 문제 해결 과정에서 직관과 논리를 결합하여 창의적인 보조선을 찾아 증명함.",
    "통계 자료를 분석하고 확률 모델을 적용하여 사회 현상의 경향성을 예측하는 보고서를 작성함.",
    "수학 동아리에서 미적분의 원리를 탐구하고 이를 활용하여 물리 현상을 설명하는 발표를 주도함.",
    "알고리즘의 효율성을 수학적으로 증명하고 이를 개선하는 코드를 작성함.",
    "오답 노트를 꾸준히 작성하며 자신의 취약점을 분석하고 극복하려는 학습 태도가 돋보임.",
    "수학의 역사적 발전 과정을 탐구하며 수학적 지식이 인류 문명에 미친 영향을 발표함.",
    "고난도 문제에 대해 친구들과 협력하여 다양한 해결 전략을 모색하고 최적의 방법을 찾아냄.",
    "추상적인 수학 개념을 시각 자료로 구체화하여 친구들의 이해를 돕는 등 의사소통 능력이 뛰어남."
  ],
  과학: [
    "탐구 실험에서 변인 통제를 정확히 하여 신뢰도 높은 데이터를 얻고 결론을 도출함.",
    "과학 원리를 실생활 문제 해결에 적용하는 발명품 아이디어를 구체적으로 제시함.",
    "최신 과학 기술 논문을 읽고 핵심 내용을 요약하여 자신의 진로 분야와 연관 지어 발표함.",
    "생명 과학 실험에서 생명 윤리 규정을 준수하며 생명 존중의 태도를 보임.",
    "복잡한 화학 반응식을 단계별로 분석하여 반응 메커니즘을 규명하는 탐구 능력을 보여줌.",
    "천체 관측 동아리에서 활동하며 별의 일주 운동과 연주 운동을 직접 촬영하고 분석함.",
    "과학적 개념을 비유와 사례를 들어 명확하게 설명하여 친구들의 이해를 도움.",
    "환경 문제의 원인을 과학적으로 분석하고 지속 가능한 발전 방안을 제시하는 보고서를 작성함.",
    "실험 데이터의 오차 원인을 분석하고 통계적으로 처리하여 결과의 정확성을 높임."
  ],
  사회: [
    "역사적 사건에 대해 다양한 사료를 비교 분석하여 편향되지 않은 시각을 제시함.",
    "국제 현안 토의 활동에서 다양한 입장을 비교하며 쟁점에 대한 분석력을 보여줌.",
    "지역 사회의 문제를 발굴하고 설문 조사와 인터뷰를 통해 해결 방안을 모색하는 프로젝트를 수행함.",
    "법과 정치의 기본 원리를 이해하고 현실 사례에 적용하여 법치주의의 중요성을 발표함.",
    "시장 경제의 작동 원리를 분석하고 정부의 역할을 비판적으로 고찰하는 소논문을 작성함.",
    "지리 정보 시스템(GIS)을 활용하여 도시의 공간 구조 변화를 분석하고 미래를 예측함.",
    "다문화 사회의 갈등 사례를 조사하고 상호 존중을 바탕으로 한 해결 방안을 제시함.",
    "인권 문제에 대한 깊은 감수성을 바탕으로 교내 인권 캠페인을 기획하고 주도함.",
    "서로 다른 관점의 자료를 비교하며 사회 현상의 다각적이고 복합적인 측면을 이해하려 노력함."
  ],
  영어: [
    "영어 원서의 문학적 표현을 깊이 있게 분석하고 작가의 의도를 파악하는 능력이 탁월함.",
    "TED 강연을 듣고 핵심 내용을 요약한 후 자신의 생각과 비판을 담아 영어로 발표함.",
    "사회적 쟁점에 대해 자신의 의견을 논리적으로 구성하여 설득력 있는 영문 에세이를 작성함.",
    "영어 토론에서 상대방의 주장을 경청하고 논리적 허점을 반박하며 자신의 주장을 방어함.",
    "영어 뉴스를 꾸준히 시청하며 국제 정세에 대한 이해를 넓히고 고급 시사 어휘를 습득함.",
    "영자 신문 동아리에서 활동하며 사회 현상을 취재하고 심층적인 기사를 작성함.",
    "외국인 학생과의 교류 활동에서 유창한 의사소통 능력으로 문화적 차이를 이해하고 존중하는 모습을 보임.",
    "복잡한 문법 구조를 정확히 이해하고 상황에 맞는 적절한 어휘를 사용하여 세련된 문장을 구사함.",
    "영어 연극에서 맡은 배역의 감정을 섬세하게 표현하여 관객의 공감을 이끌어냄."
  ],
  음악: [
    "바로크 시대와 고전 시대 음악의 양식적 차이를 비교 분석하여 감상문을 작성함.",
    "교내 오케스트라의 악장으로서 단원들의 의견을 조율하고 조화로운 합주를 이끌어냄.",
    "자신의 감정을 담아 자작곡을 만들고 미디 프로그램을 활용하여 편곡하는 능력을 보여줌.",
    "판소리의 '아니리'와 서양 오페라의 '레치타티보'를 비교하며 문화적 보편성과 특수성을 탐구함.",
    "정간보를 해독하고 시김새를 살려 단소를 연주하며 전통 음악에 대한 깊은 이해를 보임.",
    "음악 공연을 기획하고 무대 연출과 홍보까지 주도하며 기획자로서의 역량을 발휘함.",
    "음악이 인간 심리에 미치는 영향에 대해 탐구하고 이를 활용한 음악 치료 방법을 제안함.",
    "다양한 장르의 음악을 편견 없이 감상하며 음악적 안목과 감수성을 넓히려 노력함."
  ],
  체육: [
    "팀 스포츠에서 개인의 능력보다 팀의 전략을 우선시하며 동료들과 협력하는 모습을 보임.",
    "자신의 체력적 약점을 분석하고 과학적 훈련 원리에 따라 꾸준히 노력하여 극복함.",
    "스포츠 경기의 심판 역할을 수행하며 규칙을 공정하게 적용하고 갈등 상황을 원만하게 중재함.",
    "운동 역학의 원리를 탐구하여 자신의 경기 기술을 개선하고 경기력을 향상시킴.",
    "스포츠 종목을 학급에 소개하고 모두가 즐겁게 참여할 수 있도록 규칙을 변형하여 적용함.",
    "체육 수업에 대한 만족도 설문조사를 실시하고 분석하여 개선 방안을 건의함.",
    "스포츠맨십의 중요성을 이해하고 경기 결과에 상관없이 상대방을 존중하는 태도를 보임.",
    "장애인 스포츠에 대해 조사하고 인식 개선 캠페인을 주도하며 통합 체육의 가치를 실천함."
  ],
  지리: [
    "지리 정보 시스템(GIS)을 활용하여 상권의 입지 요인을 분석하고 최적의 입지를 제안하는 프로젝트를 수행함.",
    "기후 변화가 지역 주민의 생활에 미치는 영향을 심층 인터뷰를 통해 생생하게 보고서로 작성함.",
    "우리나라의 하천 지형과 해안 지형의 형성 과정을 답사하고 비교 분석하여 발표함.",
    "다국적 기업의 공간적 분업이 세계 경제에 미치는 영향을 다양한 사례를 들어 설명함.",
    "도시 재개발 과정에서 발생하는 젠트리피케이션 문제의 해결 방안을 구체적으로 제시함.",
    "지도에 표현된 정보를 비판적으로 해석하고 지도가 담고 있는 권력 관계를 분석함.",
    "여행 경험을 바탕으로 자신만의 주제를 담은 인문 지리 답사 코스를 기획하고 발표함."
  ],
  미술: [
    "자신만의 독창적인 조형 언어를 탐구하여 사회적 메시지를 담은 설치 미술 작품을 제작함.",
    "미술사조의 변천 과정을 사회·문화적 배경과 연결하여 체계적으로 발표함.",
    "다양한 재료의 물리적 특성을 실험하고 이를 효과적으로 활용하여 작품의 주제를 표현함.",
    "교내 전시회를 기획하며 작품 선정부터 공간 디자인, 홍보까지 총괄하는 큐레이터의 역량을 보여줌.",
    "미술 작품 비평 활동에서 형식주의와 맥락주의 관점을 모두 활용하여 균형 잡힌 시각을 제시함.",
    "색채 심리학을 탐구하고 이를 적용하여 특정 감정을 유발하는 공간을 디자인함.",
    "전통 회화의 기법과 재료를 연구하고 이를 현대적으로 재해석한 작품을 제작함."
  ],
  기가정보: [ // 기술가정 + 정보
    "아두이노와 센서를 활용하여 일상생활의 불편함을 해결하는 IoT 장치를 설계하고 제작함.",
    "자신의 식습관을 분석하고 영양학적 균형을 고려한 건강 식단을 직접 설계하고 조리함.",
    "파이썬을 이용하여 공공데이터를 분석하고 사회 문제의 해결 방안을 시각화하여 제시함.",
    "지속 가능한 발전을 위한 적정 기술 사례를 조사하고 우리나라에 적용할 방안을 제안함.",
    "가족의 생애 주기를 고려하여 합리적인 재무 설계 포트폴리오를 작성하고 발표함.",
    "정보 윤리의 중요성을 인식하고 개인정보 보호를 위한 기술적, 제도적 방안을 탐구함.",
    "목공 기술을 익혀 자신에게 필요한 가구를 직접 디자인하고 제작하는 자기주도성을 보임."
  ],
  역사: [
    "1차 사료와 2차 사료를 구분하고 사료의 진실성과 편향성을 비판적으로 분석하는 능력을 보여줌.",
    "특정 역사적 사건에 대해 시대적 배경과 인물의 관점을 종합적으로 고려하여 입체적으로 해석함.",
    "역사적 사실을 바탕으로 가상의 시나리오를 작성하며 역사적 상상력을 발휘함.",
    "지역의 역사 유적을 답사하고 보고서를 작성하여 향토사에 대한 깊은 애정을 드러냄.",
    "역사학의 다양한 연구 경향을 비교하며 역사가 시대에 따라 어떻게 해석되는지를 탐구함.",
    "구술사 연구 방법을 활용하여 어르신들의 생생한 경험을 기록하고 현대사의 일부로 재구성함.",
    "역사 왜곡 문제에 대해 논리적으로 반박하고 올바른 역사 인식을 확립하기 위한 캠페인을 주도함."
  ],
  한문: [
    "사서삼경의 구절을 인용하여 자신의 삶의 자세에 대해 성찰하는 글을 작성함.",
    "한문 소설을 원문으로 강독하며 당시의 사회상과 인물들의 가치관을 깊이 있게 이해함.",
    "한자의 부수와 형성 원리를 체계적으로 학습하여 모르는 한자의 뜻을 유추하는 능력이 뛰어남.",
    "한시의 형식적 특징과 함축적 의미를 이해하고 직접 한시를 창작하여 발표함.",
    "한문 기록에 담긴 선인들의 지혜를 현대 사회의 문제 해결에 적용할 방안을 모색함."
  ],
  제2외국어: [
    "해당 언어권의 문화적 맥락을 이해하고 비언어적 표현까지 사용하여 원어민 수준의 의사소통을 구사함.",
    "관심 있는 분야의 외국어 학술 자료를 읽고 핵심 내용을 번역하여 친구들과 공유함.",
    "외국어 속담과 격언을 통해 해당 언어권 사람들의 가치관과 사고방식을 탐구함.",
    "외국어 단편 소설을 읽고 작품의 문학성을 분석하여 원어와 한국어로 감상평을 작성함.",
    "자신이 배운 외국어를 활용하여 지역의 외국인 관광객을 위한 안내 봉사활동에 참여함."
  ],
  도덕: [
    "칸트의 의무론과 벤담의 공리주의를 현실의 윤리적 딜레마 상황에 적용하여 비교 분석함.",
    "생명 윤리, 정보 윤리 등 현대 사회의 복잡한 윤리 문제에 대해 깊이 있게 탐구하고 자신의 입장을 정립함.",
    "교내 토론회에서 소수자 인권 문제에 대해 논리적이고 윤리적인 근거를 들어 옹호함.",
    "봉사활동을 꾸준히 실천하며 이웃과 더불어 삶의 중요성을 내면화하고 성찰일지를 작성함.",
    "정의로운 사회를 만들기 위한 시민의 역할에 대해 탐구하고 자신이 실천할 수 있는 방안을 제시함."
  ]
};

// 교과별 강조 포인트 (학습 활동 예시 중심으로 대폭 확장 - 2차)
export const subjectEmphasisPoints = {
  국어: [
    "문학 작품 심층 분석 (작가 탐구, 상징 분석 등)",
    "비문학/매체 텍스트 비판적 읽기 (사설, 광고 분석)",
    "논리적 토론 및 설득력 있는 발표",
    "주제 탐구 보고서 작성 (자료 조사 및 분석)",
    "창의적 글쓰기 (시, 소설, 수필 창작 활동)",
    "고전 문학의 현대적 재해석 (각색, 패러디 등)",
    "화법과 작문 능력 (상황에 맞는 글쓰기, 언어 예절)",
    "의사소통 과정에서의 갈등 조정 및 협업 능력",
    "문법 지식의 탐구 및 적용 능력",
    "주제 탐구 소논문 작성",
    "시나리오 작성 및 영상 제작 활동",
    "문학 작품 낭독 및 연극 활동",
    "교내 백일장, 글쓰기 대회 참여",
    "독서 포트폴리오 제작 및 발표",
    "지역 방언 탐구 및 보고서 작성",
    "자신만의 어휘 사전 만들기 프로젝트",
    "매체 비평 동아리 활동 주도"
  ],
  수학: [
    "수학적 모델링을 통한 실생활 문제 해결",
    "고난도 문제 해결을 위한 끈기와 도전",
    "수학적 개념의 심층적 이해와 증명",
    "통계 자료 분석 및 비판적 해석 능력",
    "알고리즘 설계 및 수학적 원리 적용",
    "수학 지식 나눔 및 또래 멘토링",
    "수학과 타 교과(과학, 예술 등) 융합 탐구",
    "창의적인 문제 해결 전략 제시",
    "수학적 오류 분석 및 수정 능력",
    "수학사 탐구 및 특정 수학자 연구 발표",
    "통계 포스터 제작 및 발표",
    "코딩(Python 등)을 활용한 수학 문제 해결",
    "수학 교구 제작 및 원리 설명",
    "금융 수학 원리 탐구 및 포트폴리오 설계",
    "기하학적 작도 및 탐구 활동",
    "수학 관련 도서 독후 활동 및 토론",
    "데이터 시각화 프로젝트"
  ],
  과학: [
    "자기주도적 탐구 실험 설계 및 수행",
    "실험 데이터의 정밀한 분석 및 결론 도출",
    "과학 이론의 실생활 적용 및 발명 아이디어",
    "최신 과학 논문/기사 분석 및 발표",
    "과학 관련 사회적 쟁점(SSI) 토론",
    "융합과학(STEAM) 프로젝트 수행 능력",
    "과학적 글쓰기 (탐구 보고서, 소논문)",
    "과학 실험 기구의 능숙한 활용 및 안전의식",
    "과학 지식을 활용한 봉사활동 (과학 재능기부 등)",
    "R&E (Research & Education) 프로그램 참여",
    "과학 UCC 또는 다큐멘터리 제작",
    "장기적인 관찰 및 연구 (식물 성장, 천체 관측 등)",
    "과학 실험 개선 방안 제안 및 검증",
    "과학 원리를 이용한 교구 개발 및 시연",
    "생명 윤리 관련 주제 심층 토론",
    "첨단 과학 기술(AI, 나노) 탐구 및 발표",
    "과학 박람회 및 경진대회 참여"
  ],
  사회: [
    "역사 사료의 비판적 분석 및 다각적 해석",
    "사회 문제 탐구 및 정책 대안 제시",
    "지리 정보(GIS) 활용 및 공간 분석 능력",
    "법률/판례 분석 및 법적 사고력",
    "경제 현상 분석 및 예측 모델링",
    "법정 토론, 국제 현안 토의 등 시뮬레이션 활동 참여",
    "문화 다양성 존중 및 국제 협력 방안 모색",
    "사회 현장 조사(설문, 인터뷰) 및 분석 능력",
    "인권 감수성 및 사회적 약자 연대 활동",
    "특정 사회/역사 주제에 대한 다큐멘터리 제작",
    "지역사회 문제 해결을 위한 캠페인 기획 및 참여",
    "정치/경제/사회 관련 고전 강독 및 토론",
    "자신만의 연표 또는 역사 지도 제작",
    "국제 분쟁 지역 심층 연구 및 해결 방안 모색",
    "가상 투자 및 경제 시뮬레이션 활동",
    "헌법 조항 분석 및 개정 제안 활동",
    "글로벌 이슈에 대한 영어 토론 및 발표"
  ],
  영어: [
    "영어 원서 및 학술 자료 비판적 강독",
    "논리적이고 설득력 있는 영문 에세이 작성",
    "유창한 영어 토론 및 프레젠테이션 능력",
    "영자 신문 기사 작성 및 미디어 제작",
    "문화 콘텐츠(문학, 영화) 번역 및 소개",
    "국제 교류 활동 기획 및 주도",
    "시사 이슈에 대한 심층적 이해와 토론",
    "영어 말하기 활동 및 국제 현안 토의 참여",
    "공인 영어 시험에서의 우수한 성취",
    "영어 희곡 각색 및 연극 공연",
    "영어 소설 또는 시 창작 활동",
    "관심 분야 영문 웹사이트/블로그 제작 및 운영",
    "지역 사회 외국인을 위한 통/번역 봉사",
    "영어권 문화의 특정 주제 심층 연구 발표",
    "TED 강연 스크립트 분석 및 자신만의 강연 제작",
    "영어 어원 탐구를 통한 어휘 확장 프로젝트",
    "영어 팝송/시를 활용한 의미 분석 및 발표"
  ],
  음악: [
    "악기 연주 능력 및 정기 연주회 참여",
    "작곡 및 미디(MIDI) 프로그램을 활용한 편곡",
    "음악사조 및 작품 배경 심층 탐구",
    "음악 비평문 작성 및 발표",
    "합창, 합주에서의 리더십과 협동 능력",
    "음악 공연 기획 및 연출 경험",
    "음악과 타 예술 장르 융합 프로젝트",
    "우리 전통 음악(국악)의 계승 및 발표",
    "음악을 통한 봉사활동 (연주 봉사 등)",
    "교내 행사 음악 감독 및 음향 담당",
    "음악치료의 원리 및 효과 탐구",
    "특정 음악가(작곡가/연주가) 심층 연구",
    "영화/광고 음악 분석 및 제작",
    "음악 관련 진로 탐색 및 전문가 인터뷰",
    "음악 저작권 및 산업 구조 연구",
    "대중음악의 사회적 영향력 분석",
    "새로운 악기 개발 또는 기존 악기 개량 제안"
  ],
  체육: [
    "특정 스포츠 종목의 경기력 및 기술 심화",
    "팀 스포츠에서의 전략 분석 및 리더십",
    "과학적 원리를 적용한 훈련 계획 및 실천",
    "스포츠맨십과 페어플레이 정신 실천 사례",
    "교내 스포츠 리그/대회 기획 및 운영",
    "심판 및 경기 운영 보조 활동 참여",
    "체육 관련 진로 탐색 및 보고서 작성",
    "건강 관리 및 체력 증진 프로젝트",
    "새로운 스포츠 종목 탐구 및 소개 활동",
    "운동 역학 및 스포츠 생리학 탐구",
    "재활 운동 및 스포츠 마사지 이론 학습",
    "스포츠 데이터 분석 및 경기력 향상 방안 연구",
    "지역 사회 체육 시설 분석 및 개선 방안 제안",
    "장애인 스포츠 종목 체험 및 인식 개선 활동",
    "스포츠 윤리 문제(도핑, 승부조작) 탐구 및 토론",
    "스포츠 용품/시설 설계 및 개선 아이디어",
    "응급처치법(CPR) 및 안전 교육 이수 및 홍보"
  ],
  지리: [
    "현장 답사를 통한 지리 현상 탐구",
    "GIS, 위성사진 등 지리 정보 기술 활용 능력",
    "도시 문제 및 지역 개발 계획 분석",
    "기후 변화와 환경 문제에 대한 심층 탐구",
    "인문지리적 관점에서의 문화 현상 분석",
    "지도 제작 및 통계 지도 분석 능력",
    "지역 격차 문제에 대한 해결 방안 제시",
    "지리와 연계된 진로 탐색 보고서 작성",
    "자연재해의 원인 분석 및 대비책 연구",
    "여행 경로 설계 및 지리적 의미 분석",
    "특정 지역의 장소성(Placeness) 탐구",
    "지정학적 갈등 원인 분석 및 보고서 작성",
    "지속가능한 관광(생태관광) 모델 개발",
    "우리 동네 지도 만들기 프로젝트",
    "세계 자원 분포 및 갈등 연구",
    "교통망 발달에 따른 공간 구조 변화 분석",
    "인구 문제(저출산, 고령화)의 지리적 접근"
  ],
  미술: [
    "개인 작품 전시회 기획 및 개최",
    "미술사조 및 작가 심층 연구 발표",
    "다양한 매체(유화, 조소, 설치, 영상) 활용 능력",
    "미술 작품 비평 및 큐레이팅 활동",
    "사회적 메시지를 담은 공공미술 프로젝트 참여",
    "디자인 공모전 참여 및 수상 실적",
    "미술과 기술(미디어 아트 등) 융합 시도",
    "전통 미술 기법의 계승 및 현대적 재해석",
    "미술 재능을 활용한 벽화 그리기 등 봉사활동",
    "미술 치료의 원리 및 사례 연구",
    "특정 미술관/박물관 심층 분석 보고서",
    "색채 심리학 탐구 및 적용",
    "건축 디자인 및 공간 설계 프로젝트",
    "캐릭터 및 브랜드 아이덴티티(BI) 디자인",
    "미술품 복원 및 보존 과학 탐구",
    "패션 디자인 및 제작",
    "사진/영상 촬영 및 편집 기술"
  ],
  기가정보: [
    "프로그래밍 언어(Python, C++ 등) 활용 프로젝트",
    "앱(App) 개발 및 소프트웨어 공모전 참여",
    "로봇 제작 및 제어, 관련 대회 참여",
    "데이터베이스 설계 및 빅데이터 분석",
    "정보 보안 및 해킹 원리 탐구",
    "가정생활의 문제 해결을 위한 발명품 제작",
    "지속가능한 기술(적정기술) 탐구 및 제작",
    "영양학 기반 식단 설계 및 조리 실습",
    "가정 경제 및 재무 설계 프로젝트",
    "인공지능(AI) 윤리 문제 탐구 및 토론",
    "사물인터넷(IoT) 기기 제작 및 활용",
    "3D 프린터를 활용한 시제품 제작",
    "의류 리폼 및 업사이클링 프로젝트",
    "목공 및 생활용품 DIY 제작",
    "생애 주기별 발달 과업 및 가족 관계 연구",
    "소비자 권리 및 합리적 소비 방안 연구",
    "코딩 교육 봉사활동 참여"
  ],
  역사: [
    "특정 역사 주제에 대한 소논문 작성",
    "역사 유적 답사 및 보고서 작성",
    "역사 다큐멘터리 제작 및 발표",
    "사료 비판 및 해석 능력 심화",
    "역사적 관점의 시사 문제 분석",
    "구술사 연구 (인터뷰를 통한 역사 기록)",
    "역사 관련 토론 동아리 활동 주도",
    "잘못된 역사 상식 바로잡기 캠페인",
    "박물관/기념관 도슨트 활동 참여"
  ],
  한문: [
    "한문 원전 강독 및 번역 (사서, 제자백가 등)",
    "한시 창작 및 비평 활동",
    "한자를 활용한 캘리그래피 및 서예 활동",
    "한문 기록 속 인물 및 사상 탐구",
    "한자 성어 및 고사성어의 현대적 적용",
    "한문학과 타 교과(역사, 철학) 융합 연구",
    "한문 경전 암송 및 토론 대회 참여",
    "한자 부수 및 어원 탐구를 통한 어휘력 심화",
    "지역 문화재의 한문 기록 해독 및 소개"
  ],
  제2외국어: [
    "원어민 수준의 회화 능력 및 토론 참여",
    "해당 언어 문학 작품 번역 및 소개",
    "해당 언어권 문화/사회 심층 탐구 발표",
    "외국어 말하기/쓰기 대회 참여 및 수상",
    "외국어 통역 및 번역 봉사활동",
    "해당 언어를 사용한 영상 콘텐츠 제작",
    "해당 언어권 자매결연 학교와의 교류 주도",
    "비즈니스 외국어 및 실용 작문 능력",
    "해당 언어 자격 시험(FLEX, HSK, JLPT 등) 우수 성적"
  ],
  도덕: [
    "윤리적 딜레마 사례 분석 및 토론",
    "현대 사회의 윤리 문제(생명, 정보, 환경) 탐구",
    "윤리학 고전(아리스토텔레스, 칸트 등) 강독",
    "인권 문제 실태 조사 및 개선 캠페인",
    "봉사활동의 철학적 의미 성찰 및 보고서 작성",
    "모의 국민청원 및 사회 정책 제안",
    "정의, 평등, 자유 등 추상적 가치에 대한 탐구",
    "또래 상담 및 갈등 중재 활동",
    "자신의 삶에 대한 윤리적 성찰 일지 작성"
  ]
};

// 성취기준 참고 정보 (초중고 통합 대규모 확장)
export const sampleAchievements = {
  국어: [
    "[6국01-05] 상대의 감정을 고려하며 듣고 말하는 태도를 지닌다.",
    "[9국02-04] 작품의 사회·문화적 배경을 바탕으로 작품을 이해하고 평가한다.",
    "[12언매01-04] 국어의 음운 변동을 탐구하고 정확하게 발음하며 표기한다.",
    "[12화법02-02] 다양한 유형의 담화와 글을 비판적으로 분석하고 평가하며 듣거나 읽는다.",
    "[12독서02-04] 동일한 화제를 다룬 다양한 분야의 글을 읽고 주제 통합적으로 재구성하여 새로운 의미를 창출한다.",
    "[12문학02-03] 문학의 수용과 생산 활동을 통해 성찰하고 소통하며 공동체의 문화 발전에 기여하는 태도를 지닌다."
  ],
  수학: [
    "[6수01-12] 비와 비율을 이해하고 이를 활용하여 문제를 해결할 수 있다.",
    "[9수01-09] 이차함수의 그래프의 성질을 이해한다.",
    "[9수04-04] 피타고라스 정리를 이해하고 이를 활용하여 문제를 해결할 수 있다.",
    "[10수(상)10-02] 점과 직선 사이의 거리를 구할 수 있다.",
    "[기하12-04] 공간벡터의 뜻을 알고, 벡터의 연산을 할 수 있다.",
    "[미적분12-04] 여러 가지 함수의 미분법을 알고, 이를 활용하여 문제를 해결할 수 있다."
  ],
  과학: [
    "[6과04-02] 여러 가지 기체를 발생시키는 실험을 할 수 있다.",
    "[9과10-02] 생물 다양성 보전의 필요성을 인식하고 보전 방안에 대해 토론할 수 있다.",
    "[10통과05-03] 산화 환원 반응이 우리 주변에서 다양하게 이용됨을 설명할 수 있다.",
    "[물리학Ⅰ12-05] 운동량 보존 법칙을 이용하여 충돌 현상을 정량적으로 설명할 수 있다.",
    "[화학Ⅰ12-04] 화학 반응에서 동적 평형 상태를 이해하고, 가역 반응의 특징을 설명할 수 있다.",
    "[생명과학Ⅱ12-09] 유전자 발현 조절의 원리를 설명할 수 있다."
  ],
  사회: [
    "[6사02-03] 정치 참여의 의미와 중요성을 이해한다.",
    "[9사08-03] 일상생활에서 발생하는 법적 문제를 해결하기 위한 절차와 기관의 역할을 탐색한다.",
    "[10통사09-02] 세계화 시대에 나타나는 문제점을 파악하고 해결 방안을 모색한다.",
    "[정치와법12-02] 헌법의 의의와 기능을 이해하고, 기본권 보장의 중요성을 설명할 수 있다.",
    "[경제12-03] 시장 가격의 결정과 변동 원리를 이해하고, 수요와 공급의 변화 요인을 분석할 수 있다.",
    "[세계사12-05] 제국주의의 등장 배경과 침략 전쟁의 전개 과정을 파악하고, 식민지 민중의 저항을 탐색한다."
  ],
  영어: [
    "[6영03-01] 일상생활이나 친숙한 일반적 주제에 관해 간단히 묻거나 답한다.",
    "[9영02-01] 친숙한 일반적 주제에 관한 말이나 대화를 듣고 세부 정보를 파악할 수 있다.",
    "[10영04-02] 일반적/다양한 주제에 관한 글을 읽고 내용의 논리적 관계를 파악할 수 있다.",
    "[영어독해와작문12-05] 다양한 주제에 관한 글을 읽고 주제와 요지를 파악할 수 있다.",
    "[영어권문화12-02] 영어권 사람들의 일상생활과 사고방식을 이해하고, 문화적 다양성을 존중하는 태도를 지닌다.",
    "[영어회화12-02] 시사적인 주제에 관해 자신의 의견을 논리적으로 말할 수 있다."
  ],
  음악: [
    "[6음01-05] 바른 자세와 호흡 및 정확한 발음으로 노래 부른다.",
    "[9음01-02] 악곡의 종류에 어울리는 신체표현을 한다.",
    "[9음03-02] 음악이 역사, 사회, 문화에 미치는 영향에 대해 발표한다.",
    "[음악연주12-02] 다양한 시대와 장르의 악곡을 연주하며 음악적 표현력을 기른다.",
    "[음악감상과비평12-02] 시대별, 사조별, 작곡가별 대표적인 악곡을 감상하고 특징을 설명할 수 있다."
  ],
  체육: [
    "[6체03-01] 경쟁 스포츠에 참여하며 경기 기능과 태도를 익힌다.",
    "[9체01-04] 스포츠 정신과 공정한 경쟁의 가치를 탐색한다.",
    "[9체02-02] 도전 활동의 가치를 이해하고 자신의 수준에 맞는 과제를 계획하고 실천한다.",
    "[10운동과건강01-02] 체력 증진을 위한 운동 프로그램을 계획하고 실천하며, 그 효과를 평가한다.",
    "[스포츠생활12-01] 다양한 스포츠 활동에 참여하여 경기 기능을 발휘하고 운동 예절을 실천한다."
  ],
  지리: [
    "[9사(지리)05-01] 지역의 의미와 지역 구분 방법을 이해한다.",
    "[10통사02-02] 자연환경이 인간 생활에 미치는 영향을 다양한 사례를 통해 파악한다.",
    "[한국지리12-03] 우리나라의 인구 분포 및 인구 구조의 특징을 파악하고, 인구 문제를 해결하기 위한 방안을 모색한다.",
    "[세계지리12-05] 다양한 지역의 갈등과 불평등 사례를 통해 원인과 해결 방안을 탐색한다.",
    "[여행지리12-02] 여행 정보를 수집, 분석, 활용하여 주제와 목적에 맞는 여행을 계획하고 발표한다."
  ],
  미술: [
    "[6미01-04] 표현 의도에 적합한 주제를 다양한 방식으로 탐색할 수 있다.",
    "[9미02-01] 주제의 특징과 표현 의도에 적합한 조형 요소와 원리를 탐색하여 효과적으로 활용할 수 있다.",
    "[9미03-02] 미술 작품에 대한 개인의 해석과 평가 기준을 설명할 수 있다.",
    "[미술창작12-02] 다양한 매체와 기법을 활용하여 자신의 아이디어를 시각적으로 표현할 수 있다.",
    "[디자인일반12-01] 디자인의 가치와 역할을 이해하고, 디자인이 인간 생활에 미치는 영향을 설명할 수 있다."
  ],
  기가정보: [
    "[6실04-07] 절차적 사고에 의한 문제 해결의 순서를 생각하고 적용할 수 있다.",
    "[9기08-01] 문제 해결을 위한 아이디어를 다양한 방법으로 구상하고 구체화한다.",
    "[10기술가정03-02] 저작권 보호의 중요성을 이해하고, 자신의 저작물을 관리하며 타인의 저작권을 존중하는 태도를 갖는다.",
    "[정보12-02] 컴퓨팅 사고력의 구성 요소를 이해하고 문제 해결 과정에 적용한다.",
    "[인공지능기초12-01] 인공지능의 원리를 이해하고, 다양한 분야에서의 활용 사례를 탐색한다."
  ],
  역사: [
    "[6사03-01] 고조선의 건국과 발전 과정을 통하여 우리나라 역사의 시작과 특징을 파악한다.",
    "[9사(역사)04-01] 개항 이후 외국 문물의 수용과 근대 문물의 발달상을 살펴본다.",
    "[10한사06-03] 대한민국 정부 수립 이후 민주주의가 발전해 온 과정을 탐색한다.",
    "[동아시아사12-03] 동아시아 각국의 교류와 갈등이 지역 질서에 미친 영향을 파악한다.",
    "[세계문제와미래사회12-01] 현대 세계의 다양한 문제(인권, 환경, 평화 등)를 탐구하고 해결 방안을 모색한다."
  ],
  한문: [
    "[9한문03-01] 한문 기록에 담긴 선인들의 지혜와 사상을 이해한다.",
    "[10한문Ⅰ02-02] 문장의 짜임을 파악하여 한문 문장을 정확하게 풀이한다.",
    "[한문Ⅱ12-03] 다양한 주제의 한문 기록을 읽고, 현대적 삶에 필요한 가치관과 자세를 성찰한다.",
    "[고전과윤리12-01] 고전에 담긴 다양한 윤리 사상과 인간상을 탐구하고 현대적 의의를 성찰한다."
  ],
  제2외국어: [
    "[9중국어Ⅰ02-01] 중국어의 성모, 운모, 성조를 구별하여 발음한다.",
    "[10일본어Ⅰ03-02] 일상생활의 친숙한 주제에 대해 간단한 문장으로 쓰고 말할 수 있다.",
    "[프랑스어Ⅱ12-04] 다양한 매체를 통해 접한 정보를 활용하여 프랑스 문화에 대해 소개할 수 있다.",
    "[독일어Ⅰ10-03] 간단한 어휘와 표현을 사용하여 자신의 생각이나 느낌을 글로 쓸 수 있다."
  ],
  도덕: [
    "[6도02-01] 다양한 갈등을 평화적으로 해결하는 것의 중요성과 방법을 안다.",
    "[9도01-02] 도덕적 행동을 위한 전략을 탐구하고 실천 방안을 구안한다.",
    "[10통합사회06-02] 정의의 의미와 실질적 기준을 탐색하고, 정의로운 사회를 만들기 위한 방안을 제시한다.",
    "[생활과윤리12-02] 생명 윤리의 다양한 쟁점을 이해하고, 생명 존중의 중요성을 설명할 수 있다.",
    "[윤리와사상12-01] 윤리 문제에 대한 다양한 사상적 접근을 비교·분석하고, 자신의 관점에서 평가한다."
  ]
};

// 과목별 수행평가 예시
export const subjectPerformanceAssessment = {
  국어: [
    "문학 작품 분석 보고서 작성 및 발표",
    "토론 대회 참여 및 논리적 주장 전개",
    "창작 시집 제작 및 낭송회 개최",
    "연극 대본 각색 및 연기 활동",
    "매체 비평문 작성 (영화, 광고 등)",
    "독서 포트폴리오 제작 및 서평 작성"
  ],
  수학: [
    "실생활 문제 해결을 위한 수학적 모델링",
    "통계 프로젝트 수행 및 결과 발표",
    "수학 원리 설명 동영상 제작",
    "기하 작도 및 증명 과정 설명",
    "확률 실험 설계 및 분석",
    "수학사 탐구 보고서 작성"
  ],
  과학: [
    "자유 주제 탐구 실험 설계 및 수행",
    "과학 원리 설명 UCC 제작",
    "환경 문제 해결 방안 제안서 작성",
    "과학 도서 독후감 및 토론",
    "실험 보고서 작성 및 결과 분석",
    "과학 관련 사회 이슈 토론 참여"
  ],
  사회: [
    "역사 인물 심층 연구 발표",
    "사회 문제 해결 정책 제안서 작성",
    "지역 사회 현장 조사 및 보고서",
    "모의 재판 또는 모의 국회 참여",
    "시사 토론 및 논술문 작성",
    "문화 비교 연구 프로젝트"
  ],
  영어: [
    "영어 에세이 작성 및 첨삭 활동",
    "영어 토론 대회 참여",
    "영어 연극 또는 뮤지컬 공연",
    "영어 뉴스 청취 및 요약 발표",
    "영어 소설 독후감 작성",
    "문화 교류 프로젝트 기획 및 참여"
  ],
  음악: [
    "개인 또는 그룹 연주 발표회",
    "음악 감상문 작성 및 발표",
    "작곡 또는 편곡 활동",
    "음악사 연구 프로젝트",
    "음악 비평 활동",
    "교내 음악회 기획 및 참여"
  ],
  체육: [
    "개인 체력 향상 계획 수립 및 실천",
    "팀 스포츠 전략 분석 및 적용",
    "건강 관리 프로젝트 수행",
    "스포츠 규칙 연구 및 개선 제안",
    "운동 기능 분석 및 개선 방안 제시",
    "체육 이론 학습 및 적용"
  ],
  지리: [
    "지역 답사 계획 수립 및 실행",
    "지리 정보 시스템(GIS) 활용 프로젝트",
    "기후 변화 영향 분석 보고서",
    "도시 계획 및 개발 방안 제안",
    "지도 제작 및 분석 활동",
    "지리적 현상 탐구 발표"
  ],
  미술: [
    "개인 작품집 제작 및 전시",
    "미술사 연구 및 작가 분석",
    "창작 과정 포트폴리오 작성",
    "미술 비평문 작성",
    "공동 작품 제작 프로젝트",
    "디자인 씽킹 프로젝트 참여"
  ],
  기가정보: [
    "프로그래밍 프로젝트 완성 및 발표",
    "생활 문제 해결 앱 개발",
    "정보 윤리 사례 분석 및 토론",
    "디지털 콘텐츠 제작",
    "가정 관리 계획 수립 및 실천",
    "기술 활용 창작물 제작"
  ],
  역사: [
    "역사 탐구 보고서 작성",
    "사료 분석 및 해석 활동",
    "역사 재연 또는 체험 활동",
    "역사 다큐멘터리 제작",
    "역사 토론 및 논술",
    "지역사 조사 프로젝트"
  ],
  한문: [
    "한문 원전 번역 및 해석",
    "한시 창작 및 감상 활동",
    "서예 작품 제작 및 전시",
    "한자 어원 탐구 프로젝트",
    "고전 사상 현대적 적용 보고서",
    "한문 암송 및 해설 발표"
  ],
  제2외국어: [
    "외국어 회화 실력 향상 프로젝트",
    "해당 언어권 문화 탐구 발표",
    "외국어 작품 번역 및 소개",
    "언어 교환 프로그램 참여",
    "외국어 콘텐츠 제작",
    "국제 교류 활동 기획"
  ],
  도덕: [
    "윤리적 딜레마 사례 분석",
    "도덕 철학 탐구 보고서",
    "인권 캠페인 기획 및 참여",
    "봉사활동 성찰 보고서",
    "갈등 해결 사례 연구",
    "도덕적 실천 계획 수립"
  ]
};

// 과목별 학습태도 예시
export const subjectLearningAttitude = {
  국어: [
    "문학 작품에 대한 깊은 관심과 애정을 보임",
    "어려운 어휘도 적극적으로 찾아보며 학습",
    "자신의 생각을 논리적으로 표현하려 노력",
    "친구들의 의견을 경청하고 존중하는 태도",
    "꾸준한 독서를 통한 자기계발 의지",
    "언어의 아름다움을 느끼고 탐구하는 자세"
  ],
  수학: [
    "복잡한 문제도 포기하지 않고 끝까지 도전",
    "오답을 통해 배우려는 적극적인 학습 자세",
    "수학적 원리를 이해하려는 강한 의지",
    "논리적 사고를 통한 체계적 접근",
    "친구들과 협력하여 문제를 해결하려는 태도",
    "수학의 실용성을 인식하고 활용하려는 노력"
  ],
  과학: [
    "자연 현상에 대한 끊임없는 호기심",
    "실험 과정에서 보이는 세심한 관찰력",
    "가설 설정과 검증에 대한 과학적 태도",
    "안전 수칙을 철저히 지키는 책임감",
    "실험 결과에 대한 객관적 분석 자세",
    "과학 지식을 실생활에 적용하려는 의지"
  ],
  사회: [
    "사회 현상에 대한 비판적 사고력",
    "다양한 관점을 수용하려는 열린 자세",
    "역사적 사실에 대한 객관적 접근",
    "사회 문제 해결에 대한 적극적 관심",
    "민주적 의사결정 과정에 참여하는 태도",
    "공동체 의식을 바탕으로 한 협력 정신"
  ],
  영어: [
    "영어 학습에 대한 지속적인 열정",
    "실수를 두려워하지 않는 적극적 태도",
    "다문화에 대한 이해와 존중",
    "영어로 소통하려는 강한 의지",
    "자기주도적 학습 습관 형성",
    "국제적 감각을 기르려는 노력"
  ],
  음악: [
    "음악에 대한 순수한 열정과 애정",
    "연주나 노래에서 보이는 집중력",
    "다양한 장르의 음악을 수용하는 개방성",
    "협력적 음악 활동에서의 조화로운 태도",
    "음악적 감성을 기르려는 지속적 노력",
    "전통 음악에 대한 관심과 존중"
  ],
  체육: [
    "운동에 대한 긍정적이고 적극적인 자세",
    "자신의 한계에 도전하는 용기",
    "팀워크를 중시하는 협력적 태도",
    "공정한 경기 진행을 위한 스포츠맨십",
    "꾸준한 체력 관리에 대한 의지",
    "다양한 운동에 대한 호기심과 도전 정신"
  ],
  지리: [
    "지리적 현상에 대한 탐구 정신",
    "공간적 사고력을 기르려는 노력",
    "환경 문제에 대한 깊은 관심",
    "지역에 대한 애정과 이해",
    "지도와 자료 활용에 대한 적극성",
    "세계 시민으로서의 의식 함양"
  ],
  미술: [
    "미적 감수성을 기르려는 지속적 노력",
    "창작 활동에 대한 열정과 몰입",
    "다양한 표현 방법에 대한 탐구 의지",
    "미술 작품 감상에 대한 진지한 태도",
    "자신만의 예술적 개성을 찾으려는 노력",
    "미술을 통한 소통 의지"
  ],
  기가정보: [
    "기술에 대한 호기심과 탐구 정신",
    "문제 해결을 위한 창의적 사고",
    "정보 윤리에 대한 올바른 인식",
    "가정생활 개선에 대한 적극적 관심",
    "새로운 기술 습득에 대한 의욕",
    "실생활 적용을 위한 실용적 사고"
  ],
  역사: [
    "역사에 대한 깊은 관심과 애정",
    "과거와 현재를 연결하려는 통찰력",
    "객관적 사실 파악을 위한 노력",
    "역사적 교훈을 찾으려는 자세",
    "다양한 관점에서 역사를 바라보는 태도",
    "역사 의식을 바탕으로 한 현재적 성찰"
  ],
  한문: [
    "한문 학습에 대한 성실한 자세",
    "전통 문화에 대한 관심과 존중",
    "한자의 의미를 깊이 탐구하려는 의지",
    "고전의 지혜를 현대에 적용하려는 노력",
    "정확한 해석을 위한 꼼꼼한 학습 태도",
    "한문을 통한 인성 함양 의지"
  ],
  제2외국어: [
    "외국어 학습에 대한 강한 동기",
    "문화적 차이를 이해하려는 노력",
    "적극적인 의사소통 의지",
    "언어 학습을 통한 시야 확장 의지",
    "꾸준한 자기주도 학습 태도",
    "국제적 감각을 기르려는 노력"
  ],
  도덕: [
    "도덕적 문제에 대한 진지한 고민",
    "올바른 가치관 형성을 위한 노력",
    "타인을 배려하는 따뜻한 마음",
    "정의로운 사회를 만들려는 의지",
    "자기 성찰을 통한 성장 의지",
    "도덕적 실천에 대한 강한 의지"
  ]
};

// 과목별 탐구활동 예시
export const subjectInquiryActivities = {
  국어: [
    "지역 방언 조사 및 보존 방안 연구",
    "현대 문학 작품의 사회적 배경 탐구",
    "언어 변화 현상 추적 및 분석",
    "매체 언어의 특성 및 영향 연구",
    "문학 치료의 효과 및 적용 방안 탐구",
    "한국어의 세계화 방안 연구"
  ],
  수학: [
    "피보나치 수열의 자연계 적용 사례 탐구",
    "확률과 통계를 활용한 사회 현상 분석",
    "기하학적 원리를 활용한 건축 설계",
    "암호학의 수학적 원리 탐구",
    "수학적 모델링을 통한 환경 문제 분석",
    "인공지능 알고리즘의 수학적 기초 연구"
  ],
  과학: [
    "지역 생태계 조사 및 보전 방안 연구",
    "신재생 에너지 효율성 비교 실험",
    "미세먼지가 식물 성장에 미치는 영향 탐구",
    "발효 과정의 과학적 원리 탐구",
    "천체 관측을 통한 우주 현상 연구",
    "생활 속 화학 반응 원리 탐구"
  ],
  사회: [
    "지역 사회 문제 해결 방안 연구",
    "역사적 사건의 다각적 해석 탐구",
    "경제 정책이 사회에 미치는 영향 분석",
    "다문화 사회의 통합 방안 연구",
    "지리적 요인이 문화에 미치는 영향 탐구",
    "국제 분쟁의 원인 및 해결 방안 연구"
  ],
  영어: [
    "영어권 문화의 특징 및 차이점 탐구",
    "영어의 역사적 변천 과정 연구",
    "영어 교육 방법론 비교 분석",
    "영어권 문학의 사회적 배경 탐구",
    "국제 기구에서의 영어 사용 실태 연구",
    "영어와 한국어의 언어학적 차이 분석"
  ],
  음악: [
    "전통 음악과 현대 음악의 융합 방안 탐구",
    "음악이 뇌 발달에 미치는 영향 연구",
    "지역별 민요의 특성 및 의미 탐구",
    "음악 치료의 효과 및 적용 방안 연구",
    "디지털 음악 기술의 발전과 영향 탐구",
    "음악과 수학의 상관관계 연구"
  ],
  체육: [
    "운동이 학습능력에 미치는 영향 연구",
    "스포츠 과학 원리를 활용한 경기력 향상 방안",
    "전통 무예의 현대적 활용 방안 탐구",
    "스포츠와 인성 교육의 상관관계 연구",
    "장애인 스포츠의 발전 방향 탐구",
    "스포츠 산업의 현황 및 전망 연구"
  ],
  지리: [
    "기후 변화가 농업에 미치는 영향 탐구",
    "도시화 현상의 원인 및 대책 연구",
    "지형이 인간 생활에 미치는 영향 분석",
    "관광 자원 개발과 환경 보전의 조화 방안",
    "인구 이동 패턴 분석 및 예측",
    "지역 격차 해소 방안 연구"
  ],
  미술: [
    "색채가 인간 심리에 미치는 영향 탐구",
    "전통 미술의 현대적 계승 방안 연구",
    "미술과 과학 기술의 융합 사례 탐구",
    "공공 미술의 사회적 역할 연구",
    "미술 치료의 효과 및 적용 방안 탐구",
    "디지털 아트의 발전과 전망 연구"
  ],
  기가정보: [
    "인공지능의 윤리적 문제 및 해결 방안 탐구",
    "사물인터넷(IoT)의 생활 적용 방안 연구",
    "개인정보 보호 기술 및 정책 탐구",
    "지속가능한 기술 개발 방안 연구",
    "가족 생활주기별 생활 설계 탐구",
    "미래 사회 변화와 기술의 역할 연구"
  ],
  역사: [
    "역사 왜곡 문제의 원인 및 해결 방안 탐구",
    "구술사를 통한 지역사 발굴 프로젝트",
    "역사적 인물의 리더십 분석 연구",
    "전쟁의 원인과 평화 구축 방안 탐구",
    "문화재 보존의 중요성 및 방법 연구",
    "역사 교육의 현대적 의미 탐구"
  ],
  한문: [
    "고전 속 교육 사상의 현대적 의미 탐구",
    "한자 문화권의 공통점과 차이점 연구",
    "한문 고전의 현대 문학에 미친 영향 탐구",
    "전통 윤리 사상의 현대적 적용 방안 연구",
    "한자의 조자 원리 및 변천 과정 탐구",
    "동양 철학과 서양 철학의 비교 연구"
  ],
  제2외국어: [
    "해당 언어권의 역사와 문화 심층 탐구",
    "언어와 사고의 상관관계 연구",
    "다국어 사용자의 인지적 특성 탐구",
    "해당 언어권의 교육 제도 비교 연구",
    "언어 학습이 뇌 발달에 미치는 영향 탐구",
    "해당 언어권의 사회 문제 및 해결 방안 연구"
  ],
  도덕: [
    "현대 사회 윤리 문제의 원인 및 해결 방안 탐구",
    "동서양 윤리 사상의 비교 연구",
    "인공지능 시대의 윤리적 과제 탐구",
    "환경 윤리의 필요성 및 실천 방안 연구",
    "생명 윤리 문제의 다각적 접근",
    "정의로운 사회 구현을 위한 방안 탐구"
  ]
};

// 과목별 창의성 예시
export const subjectCreativity = {
  국어: [
    "독창적인 시각으로 문학 작품 재해석",
    "창의적 글쓰기 기법 개발 및 적용",
    "새로운 형태의 매체 활용 표현",
    "문학과 타 예술 장르의 융합 시도",
    "언어유희를 활용한 창작 활동",
    "전통 문학의 현대적 변용 시도"
  ],
  수학: [
    "수학적 개념의 시각적 표현 개발",
    "일상 문제를 수학적으로 모델링하는 창의성",
    "수학 원리를 활용한 예술 작품 창작",
    "새로운 문제 해결 방법 고안",
    "수학적 패턴을 활용한 디자인 창작",
    "수학 교구 개발 및 개선 아이디어 제시"
  ],
  과학: [
    "과학 원리를 활용한 발명품 아이디어 제시",
    "실험 방법의 창의적 개선 방안 제안",
    "과학 지식을 활용한 예술 작품 창작",
    "환경 문제 해결을 위한 독창적 아이디어",
    "과학적 원리를 쉽게 설명하는 방법 개발",
    "융합 과학 프로젝트의 창의적 설계"
  ],
  사회: [
    "사회 문제 해결을 위한 창의적 정책 제안",
    "역사적 사실의 새로운 해석 및 관점 제시",
    "지역 발전을 위한 독창적 아이디어 제안",
    "문화 콘텐츠를 활용한 교육 방안 개발",
    "사회 현상을 예술로 표현하는 창의적 시도",
    "미래 사회 모습에 대한 창의적 전망"
  ],
  영어: [
    "영어 학습법의 창의적 개발 및 적용",
    "영어와 한국어의 창의적 융합 표현",
    "영어를 활용한 독창적 콘텐츠 제작",
    "문화 교류를 위한 창의적 프로그램 기획",
    "영어 교육 게임 및 활동 개발",
    "영어권 문화의 창의적 소개 방법 개발"
  ],
  음악: [
    "전통 음악과 현대 음악의 창의적 융합",
    "일상 소음을 활용한 음악 창작",
    "음악과 타 예술의 융합 작품 창작",
    "새로운 연주 기법 개발 및 적용",
    "음악을 활용한 교육 콘텐츠 개발",
    "디지털 기술을 활용한 음악 창작"
  ],
  체육: [
    "새로운 운동 방법 개발 및 제안",
    "스포츠 규칙의 창의적 변형 및 적용",
    "운동과 학습을 연계한 프로그램 개발",
    "체육 시설 개선을 위한 창의적 아이디어",
    "건강 관리를 위한 독창적 방법 개발",
    "스포츠와 예술의 융합 시도"
  ],
  지리: [
    "지리 정보의 창의적 시각화 방법 개발",
    "지역 문제 해결을 위한 독창적 접근",
    "지리적 특성을 활용한 관광 상품 개발",
    "환경 보전을 위한 창의적 캠페인 기획",
    "지도 제작의 새로운 방법론 제시",
    "지리 교육의 창의적 방법 개발"
  ],
  미술: [
    "전통 기법과 현대 기술의 창의적 결합",
    "일상 재료를 활용한 독창적 작품 창작",
    "사회 문제를 예술로 표현하는 창의적 시도",
    "새로운 미술 기법 개발 및 실험",
    "미술과 과학의 융합 작품 창작",
    "공간의 창의적 활용 및 설계"
  ],
  기가정보: [
    "생활 문제 해결을 위한 창의적 기술 개발",
    "기존 기술의 새로운 활용 방안 제시",
    "사용자 편의성을 고려한 인터페이스 설계",
    "친환경 기술 개발 아이디어 제시",
    "가정생활 개선을 위한 창의적 솔루션",
    "정보 기술을 활용한 교육 도구 개발"
  ],
  역사: [
    "역사적 사건의 새로운 관점 제시",
    "역사 교육의 창의적 방법론 개발",
    "역사적 인물의 현대적 재해석",
    "역사 콘텐츠의 창의적 제작 방법",
    "문화재 활용의 새로운 방안 제시",
    "역사적 교훈의 현대적 적용 방법 개발"
  ],
  한문: [
    "고전 문학의 현대적 변용 시도",
    "한자의 창의적 활용 방안 개발",
    "전통 사상의 현대적 해석 및 적용",
    "한문 교육의 새로운 접근 방법 제시",
    "서예와 현대 디자인의 융합 시도",
    "고전 속 지혜의 창의적 표현 방법 개발"
  ],
  제2외국어: [
    "언어 학습의 창의적 방법론 개발",
    "문화 교류를 위한 독창적 프로그램 기획",
    "해당 언어를 활용한 창의적 콘텐츠 제작",
    "언어와 문화의 융합 표현 시도",
    "외국어 교육 도구의 창의적 개발",
    "국제 이해 교육의 새로운 접근 방법"
  ],
  도덕: [
    "윤리 문제 해결을 위한 창의적 접근",
    "도덕 교육의 새로운 방법론 개발",
    "윤리적 가치의 창의적 표현 및 실천",
    "사회 문제 해결을 위한 독창적 캠페인 기획",
    "도덕적 실천의 새로운 방법 제시",
    "윤리 의식 함양을 위한 창의적 활동 개발"
  ]
};

// 과목별 협력활동 예시
export const subjectCollaboration = {
  국어: [
    "문학 동아리 운영 및 토론 활동 주도",
    "교내 문예지 발간 프로젝트 협력",
    "연극 공연을 위한 대본 창작 및 연출 협력",
    "독서 토론회 기획 및 진행",
    "교과서 재구성 프로젝트 팀 활동",
    "언어 순화 캠페인 공동 기획"
  ],
  수학: [
    "수학 문제 해결 스터디 그룹 운영",
    "수학 교구 제작 팀 프로젝트",
    "통계 조사 및 분석 공동 작업",
    "수학 원리 설명 동영상 공동 제작",
    "수학 경시대회 준비 스터디",
    "또래 튜터링 활동 적극 참여"
  ],
  과학: [
    "과학 실험 설계 및 수행 팀 활동",
    "과학 동아리 프로젝트 공동 진행",
    "환경 보전 캠페인 공동 기획",
    "과학 탐구 발표회 협력 준비",
    "과학 교구 개발 팀 프로젝트",
    "지역 사회 과학 봉사 활동 협력"
  ],
  사회: [
    "사회 문제 해결 프로젝트 팀 활동",
    "모의 국회 또는 모의 재판 협력 참여",
    "지역 사회 조사 프로젝트 공동 수행",
    "역사 탐방 및 조사 활동 협력",
    "사회 현안 토론 그룹 활동",
    "문화 다양성 이해 프로그램 공동 기획"
  ],
  영어: [
    "영어 토론 동아리 활동 적극 참여",
    "국제 교류 프로그램 공동 기획",
    "영어 연극 공연 협력 참여",
    "영자 신문 발간 프로젝트 협력",
    "영어 교육 봉사 활동 팀 참여",
    "문화 교류 행사 공동 준비"
  ],
  음악: [
    "합창단 또는 오케스트라 협력 연주",
    "음악회 기획 및 준비 팀 활동",
    "음악 동아리 운영 및 활동 주도",
    "교내 음악 행사 공동 기획",
    "전통 음악 보존 프로젝트 협력",
    "음악 교육 봉사 활동 팀 참여"
  ],
  체육: [
    "팀 스포츠에서의 전략 수립 및 실행 협력",
    "체육 대회 기획 및 운영 팀 활동",
    "건강 증진 프로그램 공동 개발",
    "스포츠 동아리 운영 및 활동 주도",
    "체육 시설 개선 프로젝트 협력",
    "지역 사회 체육 봉사 활동 팀 참여"
  ],
  지리: [
    "지역 답사 계획 수립 및 실행 협력",
    "환경 보전 프로젝트 팀 활동",
    "지리 정보 수집 및 분석 공동 작업",
    "지역 문제 해결 방안 모색 협력",
    "지도 제작 프로젝트 팀 활동",
    "국제 이해 교육 프로그램 공동 기획"
  ],
  미술: [
    "공동 작품 창작 프로젝트 협력",
    "미술 전시회 기획 및 준비 팀 활동",
    "벽화 제작 프로젝트 협력 참여",
    "미술 동아리 운영 및 활동 주도",
    "디자인 프로젝트 공동 수행",
    "미술 교육 봉사 활동 팀 참여"
  ],
  기가정보: [
    "소프트웨어 개발 프로젝트 팀 활동",
    "로봇 제작 및 프로그래밍 협력",
    "정보 윤리 캠페인 공동 기획",
    "디지털 콘텐츠 제작 팀 프로젝트",
    "가정 관리 시스템 개발 협력",
    "기술 교육 봉사 활동 팀 참여"
  ],
  역사: [
    "역사 연구 프로젝트 공동 수행",
    "역사 체험 프로그램 기획 및 운영 협력",
    "구술사 수집 프로젝트 팀 활동",
    "역사 콘텐츠 제작 협력",
    "문화재 보존 캠페인 공동 기획",
    "역사 교육 봉사 활동 팀 참여"
  ],
  한문: [
    "한문 번역 프로젝트 공동 수행",
    "서예 작품 전시회 협력 기획",
    "한문 경전 연구 그룹 활동",
    "전통 문화 체험 프로그램 공동 기획",
    "한자 교육 자료 개발 팀 프로젝트",
    "한문 교육 봉사 활동 협력"
  ],
  제2외국어: [
    "언어 교환 프로그램 공동 기획",
    "해당 언어권 문화 소개 프로젝트 협력",
    "외국어 콘텐츠 제작 팀 활동",
    "국제 교류 행사 공동 준비",
    "외국어 교육 봉사 활동 팀 참여",
    "다문화 이해 프로그램 협력 기획"
  ],
  도덕: [
    "윤리 토론 그룹 활동 적극 참여",
    "인권 캠페인 공동 기획 및 실행",
    "봉사 활동 프로그램 협력 기획",
    "갈등 해결 프로그램 공동 개발",
    "도덕적 실천 활동 팀 참여",
    "윤리 의식 함양 프로그램 협력 기획"
  ]
};

// 과목별 진로연계 예시
export const subjectCareerConnection = {
  국어: [
    "작가, 기자, 편집자 등 언어 관련 직업 탐구",
    "방송 작가, PD 등 미디어 분야 진로 탐색",
    "교사, 교수 등 교육 분야 진로 연계",
    "출판 기획자, 도서관 사서 등 관련 직업 탐구",
    "광고 카피라이터, 마케터 등 진로 탐색",
    "문화 콘텐츠 기획자 등 창작 분야 진로 연계"
  ],
  수학: [
    "수학자, 통계학자 등 순수 수학 분야 탐구",
    "데이터 사이언티스트, 빅데이터 전문가 진로 탐색",
    "보험계리사, 금융 분석가 등 금융 분야 연계",
    "AI 개발자, 알고리즘 엔지니어 진로 탐구",
    "수학 교사, 수학 교육 연구자 진로 연계",
    "암호학자, 정보보안 전문가 등 보안 분야 탐색"
  ],
  과학: [
    "의사, 간호사 등 의료 분야 진로 탐구",
    "연구원, 과학자 등 연구 분야 진로 연계",
    "환경 전문가, 생태학자 진로 탐색",
    "공학자, 기술자 등 공학 분야 연계",
    "과학 교사, 과학 교육 연구자 진로 탐구",
    "바이오 기술자, 제약 연구원 등 생명과학 분야"
  ],
  사회: [
    "외교관, 국제기구 직원 등 국제 분야 탐구",
    "변호사, 판사 등 법조 분야 진로 연계",
    "정치인, 정책 연구원 등 정치 분야 탐색",
    "경제학자, 경제 분석가 진로 탐구",
    "사회복지사, 상담사 등 복지 분야 연계",
    "언론인, 시사 평론가 등 미디어 분야"
  ],
  영어: [
    "통역사, 번역가 등 언어 전문 분야 탐구",
    "외교관, 국제기구 직원 진로 연계",
    "국제 비즈니스, 무역 전문가 진로 탐색",
    "영어 교사, 영어 교육 연구자 진로 탐구",
    "항공 승무원, 관광 가이드 등 서비스업 연계",
    "국제 변호사, 국제 회계사 등 전문직"
  ],
  음악: [
    "연주자, 지휘자 등 연주 분야 진로 탐구",
    "작곡가, 편곡가 등 창작 분야 진로 연계",
    "음악 치료사, 음악 교육자 진로 탐색",
    "음악 프로듀서, 사운드 엔지니어 진로 탐구",
    "음악 평론가, 음악 기자 등 비평 분야",
    "음악 산업 기획자, 매니저 등 기획 분야"
  ],
  체육: [
    "체육 교사, 스포츠 지도자 진로 탐구",
    "운동선수, 코치 등 경기 분야 진로 연계",
    "스포츠 의학, 재활 치료사 진로 탐색",
    "스포츠 마케터, 스포츠 기자 진로 탐구",
    "체육 시설 관리자, 스포츠 용품 개발자",
    "피트니스 트레이너, 요가 강사 등 건강 분야"
  ],
  지리: [
    "지리학자, 지리 교사 등 지리 전문 분야",
    "도시 계획가, 지역 개발 전문가 진로 연계",
    "기상학자, 환경 전문가 진로 탐색",
    "관광 기획자, 여행 작가 진로 탐구",
    "지리 정보 시스템(GIS) 전문가",
    "국토 관리, 측량 기사 등 공간 정보 분야"
  ],
  미술: [
    "화가, 조각가 등 순수 미술 분야 탐구",
    "디자이너, 일러스트레이터 진로 연계",
    "큐레이터, 미술 평론가 진로 탐색",
    "미술 치료사, 미술 교육자 진로 탐구",
    "애니메이터, 게임 아티스트 등 디지털 분야",
    "패션 디자이너, 제품 디자이너 등 응용 분야"
  ],
  기가정보: [
    "소프트웨어 개발자, 프로그래머 진로 탐구",
    "정보보안 전문가, 해킹 방어 전문가",
    "데이터 분석가, AI 엔지니어 진로 연계",
    "영양사, 조리사 등 식품 영양 분야",
    "가정 관리사, 생활 컨설턴트 진로 탐색",
    "기술 교육자, IT 강사 등 교육 분야"
  ],
  역사: [
    "역사학자, 역사 교사 등 역사 전문 분야",
    "박물관 학예사, 문화재 보존 전문가",
    "고고학자, 문화 인류학자 진로 연계",
    "역사 작가, 역사 다큐 제작자",
    "문화 관광 해설사, 문화재 해설사",
    "역사 콘텐츠 기획자, 역사 교육 개발자"
  ],
  한문: [
    "한문학자, 한문 교사 등 한문 전문 분야",
    "서예가, 전통 문화 전문가 진로 연계",
    "고전 번역가, 한문 해석 전문가",
    "문화재 연구원, 전통 문화 보존 전문가",
    "한의사, 동양학 연구자 진로 탐색",
    "전통 문화 교육자, 문화 기획자"
  ],
  제2외국어: [
    "통역사, 번역가 등 언어 전문 분야",
    "외교관, 국제기구 직원 진로 연계",
    "국제 비즈니스, 해외 영업 전문가",
    "해당 언어권 지역 전문가, 연구자",
    "국제 교육 프로그램 기획자",
    "다문화 상담사, 국제 교류 전문가"
  ],
  도덕: [
    "도덕 교사, 윤리학 연구자 진로 탐구",
    "상담사, 심리치료사 등 상담 분야",
    "사회복지사, 인권 운동가 진로 연계",
    "정책 연구원, 사회 개혁 전문가",
    "종교인, 철학자 등 사상 분야",
    "NGO 활동가, 시민 사회 전문가"
  ]
};

// 창체 전용 강조 포인트 (진로, 학과, 대학 연계 중심)
export const creativityEmphasisPoints = {
  "진로탐색": [
    "관심 분야의 직업군 심층 탐구 및 체험",
    "진로 적성 검사 결과 분석 및 활용",
    "멘토링을 통한 진로 정보 수집",
    "진로 관련 독서 및 보고서 작성",
    "진로 박람회 참여 및 정보 수집",
    "희망 직업 관련 자격증 취득 노력",
    "진로 변경 과정에서의 유연한 사고",
    "장래 희망과 연계한 학습 계획 수립"
  ],
  "학과연계": [
    "희망 학과의 교육과정 및 전망 탐구",
    "관련 학과 교수 또는 재학생 인터뷰",
    "학과별 입시 전형 분석 및 준비",
    "학과 관련 전공 서적 독서 및 탐구",
    "학과 연계 동아리 활동 적극 참여",
    "학과별 필요 역량 개발을 위한 노력",
    "관련 학과 학회 또는 세미나 참석",
    "학과 졸업생 진로 현황 조사 및 분석"
  ],
  "대학연계": [
    "목표 대학의 인재상 및 교육 철학 탐구",
    "대학별 입시 전형 분석 및 맞춤 준비",
    "목표 대학 재학생과의 멘토링 활동",
    "대학 캠퍼스 탐방 및 정보 수집",
    "대학별 특성화 프로그램 탐구",
    "목표 대학 관련 동아리 또는 활동 참여",
    "대학 입시 설명회 참석 및 정보 활용",
    "대학 생활 및 학업 계획 구체적 수립"
  ],
  "자율활동": [
    "학급 임원으로서 책임감 있는 역할 수행",
    "학교 행사 기획 및 운영 적극 참여",
    "학급 문제 해결을 위한 건설적 제안",
    "교내 자치 활동 주도적 참여",
    "학급 분위기 개선을 위한 노력",
    "학교 규칙 개선을 위한 의견 제시",
    "또래 조정 및 갈등 해결 역할",
    "학교 공동체 발전을 위한 기여"
  ],
  "동아리활동": [
    "학술 동아리에서의 전문성 개발",
    "예체능 동아리에서의 재능 발휘",
    "봉사 동아리를 통한 나눔 실천",
    "창작 동아리에서의 창의적 활동",
    "토론 동아리에서의 논리적 사고력 개발",
    "과학 동아리에서의 탐구 정신 함양",
    "문화 동아리에서의 감성 및 표현력 개발",
    "진로 관련 동아리에서의 전문 지식 습득"
  ],
  "봉사활동": [
    "지역사회 문제 해결을 위한 봉사 참여",
    "환경 보전을 위한 실천적 봉사 활동",
    "소외계층을 위한 나눔 봉사 실천",
    "교육 봉사를 통한 재능 나눔",
    "문화 봉사를 통한 지역사회 기여",
    "국제 협력 봉사 활동 참여",
    "동물 보호 및 생명 존중 봉사",
    "재해 지역 복구 봉사 활동 참여"
  ],
  "특기활동": [
    "특정 분야에서의 뛰어난 재능 발휘",
    "전문적 기능 습득을 위한 지속적 노력",
    "특기를 활용한 교내외 활동 주도",
    "재능 기부를 통한 사회 기여",
    "특기 분야 대회 참가 및 우수한 성과",
    "특기와 진로 연계한 체계적 개발",
    "특기를 통한 자신감 및 정체성 확립",
    "특기 분야 멘토링 및 후배 지도"
  ],
  "리더십개발": [
    "학생회 활동을 통한 리더십 함양",
    "프로젝트 팀장으로서의 조직 운영 능력",
    "갈등 상황에서의 중재 및 해결 능력",
    "구성원들의 의견 수렴 및 조율 능력",
    "목표 달성을 위한 전략 수립 및 실행",
    "팀워크 향상을 위한 노력과 배려",
    "솔선수범을 통한 모범적 리더십",
    "민주적 의사결정 과정 주도"
  ]
};

// 안내 메시지 (심플하게 수정)
export const achievementDisclaimer = `성취기준은 참고용입니다. 정확한 정보는 국가교육과정정보센터(ncic.re.kr)에서 확인하세요.`;

// 과목 목록 (확장)
export const subjectList = ['국어', '수학', '과학', '사회', '영어', '음악', '체육', '지리', '미술', '기가정보', '역사', '한문', '제2외국어', '도덕'];

const subjectData = {
  subjectSpecificExamples,
  subjectEmphasisPoints,
  sampleAchievements,
  subjectPerformanceAssessment,
  subjectLearningAttitude,
  subjectInquiryActivities,
  subjectCreativity,
  subjectCollaboration,
  subjectCareerConnection,
  creativityEmphasisPoints,
  achievementDisclaimer,
  subjectList
};

export default subjectData;
